import { Component, inject } from '@angular/core';
import {
    DxDataGridComponent,
    DxFormComponent,
    DxTemplateDirective,
} from 'devextreme-angular';
import {
    DxiColumnComponent,
    DxiItemComponent,
    DxoColumnChooserComponent,
    DxoExportComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoLoadPanelComponent,
    DxoPagerComponent,
    DxoPagingComponent,
    DxoPositionComponent,
    DxoScrollingComponent,
    DxoSearchComponent,
    DxoSearchPanelComponent,
    DxoSelectionComponent,
    DxoSortingComponent,
    DxoToolbarComponent,
} from 'devextreme-angular/ui/nested';
import { FilterPanelComponent } from '../../../components/library/filter-panel/filter-panel.component';
import {
    FilterConfig,
    GridPageComponent,
} from '../../common/grid-page.component';
import {
    EmptyCheckOutGridViewDto,
    EmptyCheckOutStatus,
    ShuntLocationType,
} from '@services';
import EnumUtils from '../../../shared/enum-utils';
import { CommonModule, NgClass } from '@angular/common';
import { DxDataGridTypes } from 'devextreme-angular/ui/data-grid';
import { Router, RouterLink } from '@angular/router';
import { DATE_TIME_FORMAT, YES_NO_OPTIONS } from 'src/app/shared/constants';
import { EmptyCheckOutStatusPipe } from 'src/app/pipes/empty-check-out-status.pipe';
import { CapitalCasePipe } from 'src/app/pipes/capital-case.pipe';
import { UserAvatarEmailComponent } from 'src/app/components/utils/user-avatar-email/user-avatar-email.component';

@Component({
    selector: 'app-empty-check-outs',
    imports: [
        CommonModule,
        DxDataGridComponent,
        DxoScrollingComponent,
        DxoPagingComponent,
        DxoPagerComponent,
        DxoLoadPanelComponent,
        DxoPositionComponent,
        DxoSearchComponent,
        DxoSelectionComponent,
        DxoSortingComponent,
        DxoHeaderFilterComponent,
        DxoFilterRowComponent,
        DxoColumnChooserComponent,
        DxoSearchPanelComponent,
        DxoExportComponent,
        DxoToolbarComponent,
        DxiItemComponent,
        DxiColumnComponent,
        DxTemplateDirective,
        NgClass,
        FilterPanelComponent,
        DxFormComponent,
        RouterLink,
        CapitalCasePipe,
        EmptyCheckOutStatusPipe,
        UserAvatarEmailComponent,
    ],
    providers: [EmptyCheckOutStatusPipe],
    templateUrl: './empty-check-outs.component.html',
})
export class EmptyCheckOutsComponent extends GridPageComponent<EmptyCheckOutGridViewDto> {
    private router = inject(Router);
    protected override exportName: string = 'Check-Out Report';
    protected offset: number = 100;
    public dateTimeFormat = DATE_TIME_FORMAT;

    dataSource = this.dataSources.emptyCheckOuts();

    private emptyCheckOutStatusPipe = inject(EmptyCheckOutStatusPipe);

    statusOptions = EnumUtils.getEnumOptions(EmptyCheckOutStatus, (v) =>
        this.emptyCheckOutStatusPipe.transform(v),
    );
    shuntLocationOptions = EnumUtils.getEnumOptions(ShuntLocationType);

    public yesNoOptions = YES_NO_OPTIONS;

    createdByFilter = this.userNameOrEmailFilter('createdBy');

    protected override filterConfig: FilterConfig[] = [
        { field: 'number', op: 'contains' },
        { field: 'carrier', op: 'contains' },
        { field: 'trailerNumber', op: 'contains' },
        { field: 'driverName', op: 'contains' },
        { field: 'tractor', op: 'contains' },
        { field: 'isTrailerEmpty', op: '=' },
        { field: 'sealNumber', op: 'contains' },
        { field: 'location', op: '=' },
        { field: 'shuntLocationNumber', op: 'contains' },
        { field: 'status', op: '=' },
        { field: 'created', op: '>=' },
        {
            field: 'createdBy.name',
            op: 'contains',
            customFilter: this.createdByFilter,
        },
    ];

    constructor() {
        super();
        this.init(EmptyCheckOutGridViewDto);
    }

    protected getBadgeClass(status: EmptyCheckOutStatus): string {
        return EnumUtils.getEmptyCheckOutStatusBadgeClass(status);
    }

    async onRowDblClick(e: DxDataGridTypes.RowDblClickEvent) {
        await this.router.navigate([
            `/outbound/empty-check-outs/details/${e.data.number}`,
        ]);
    }
}
